import { render } from "./01_DashobardSectionMain.vue?vue&type=template&id=73abe02a"
import script from "./01_DashobardSectionMain.vue?vue&type=script&lang=js"
export * from "./01_DashobardSectionMain.vue?vue&type=script&lang=js"

import "./01_DashobardSectionMain.vue?vue&type=style&index=0&id=73abe02a&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__